module.exports = __webpack_public_path__ + "static/media/hero-interior-living-room.ec411531.jpg";